import React from 'react';
import './chatbot.css';
import { openLivenessChatbot } from './ChatbotInitializer';

const ChatbotSupportButton = () => (
  <div className="chatbot-support-button-wrap">
    <button
      type="button"
      className="chatbot-support-button"
      onClick={openLivenessChatbot}
    >
      Ayuda
    </button>
  </div>
);

export default ChatbotSupportButton;
